import React, { memo, useCallback } from 'react';
import Button from 'jd-library/Button';

function ExportImportDownloadButton(props) {
  const { label, url, fileName } = props;

  const handleDownload = useCallback(() => {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  },[]);

  return (
    <Button onClick={handleDownload} variant="default" size="xs">
      {label}
    </Button>
  );
}

export default memo(ExportImportDownloadButton);